import {
  type Action,
  type Transfer,
  checkIfActionsIsValid,
} from '@0xtorch/core'
import type { Chain } from '../../../../chain'
import type { LowerHex, TransactionDecoded } from '../../../../types'
import { generateActions } from './generateActions'
import type { JsonAnalyzer } from './type'
import { verifyTxSatisfiesCondition } from './verifyTxSatisfiesCondition'

type CreateActionsByJsonAnalyzerParameters = {
  readonly chain: Chain
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
  readonly accountIds: Set<string>
  readonly jsonAnalyzers: readonly JsonAnalyzer[]
  readonly transfers: readonly Transfer[]
  readonly source: string
}

export const createActionsByJsonAnalyzer = ({
  chain,
  transaction,
  relatedAddresses,
  accountIds,
  jsonAnalyzers,
  transfers,
  source,
}: CreateActionsByJsonAnalyzerParameters): readonly Action[] | undefined => {
  // JSON 毎に処理
  for (const { condition, generators } of jsonAnalyzers) {
    // condition に合致するか確認
    const verified = verifyTxSatisfiesCondition({
      transaction,
      relatedAddresses,
      condition,
    })
    if (!verified) {
      continue
    }

    // generator 毎に action 生成
    // action 生成中にエラーが発生した場合は catch して次の JSON Analyzer に進む
    const actions: Action[] = []
    try {
      for (const generator of generators) {
        actions.push(
          ...generateActions({
            chain,
            transaction,
            relatedAddresses,
            source,
            generator,
          }),
        )
      }
    } catch (error) {
      console.debug(error)
      continue
    }

    // validation して問題なければ action を返す
    if (!checkIfActionsIsValid({ actions, accountIds, transfers })) {
      continue
    }
    return actions
  }

  // 全ての処理で action が生成されない場合は undefined を返す
  return undefined
}
